import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuthContext } from "@/context-state/AuthContext";
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { cn } from "@/lib/utils";
import { useCurrentSpace } from "@/hooks/useCurrentSpace";
import { useParams } from "react-router-dom";
import { Icon } from "@iconify/react";

export const SpaceSelector = ({ className, triggerClassName, contentClassName, onSpaceChange, size = "default" }) => {

    const { spaces } = useAuthContext()
    const { space } = useCurrentSpace()
    const { accountId, spaceId } = useParams()
    const navigate = useNavigate()
    const location = useLocation()


    const handleSpaceChange = (newSpaceId) => {
        // Don't do anything if selecting the current space
        if (newSpaceId === spaceId) {
            return
        }

        // Call the onSpaceChange callback if provided
        if (onSpaceChange) {
            onSpaceChange(newSpaceId)
        }

        // Update URL path to include spaceId
        const newPath = location.pathname.replace(`/space/${spaceId}`, `/space/${newSpaceId}`)
        navigate(newPath)
    }


    // Determine trigger size classes
    const sizeClasses = {
        sm: "h-8 text-xs",
        default: "h-10 text-sm",
        lg: "h-12 text-base"
    }

    if (!spaces || spaces.length === 0) {
        return null // Don't render if no spaces available
    }

    return (
        <div className={cn("flex items-center w-full", className)}>
            <Select
                value={spaceId}
                onValueChange={handleSpaceChange}
            >
                <SelectTrigger
                    className={cn(
                        "flex items-center gap-2",
                        sizeClasses[size],
                        triggerClassName
                    )}
                >
                    <SelectValue placeholder={space?.name || "Select a space"} />
                </SelectTrigger>

                <SelectContent className={cn("", contentClassName)}>
                    <SelectGroup>
                        {
                            spaces.map((spaceItem) => {
                                return (
                                    <SelectItem
                                        key={spaceItem._id}
                                        value={spaceItem._id}
                                        className="cursor-pointer"
                                    >
                                        <div className="flex items-center gap-2">
                                            {/* <Icon icon="material-symbols-light:planet-outline-rounded" className="h-4 w-4 flex-shrink-0" /> */}
                                            <span className="truncate max-w-[140px]">{spaceItem.name} </span>
                                        </div>
                                    </SelectItem>
                                )
                            })
                        }
                    </SelectGroup>
                </SelectContent>
            </Select>
        </div>
    )
}
